// Keeps #cart-icon-bubble in sync when the cart is changed outside the theme's own cart components
// (e.g. the Qikify Slide Cart app intercepts add-to-cart, so cart-notification/cart-drawer never re-render it).
// Also dispatches a `cart:changed` document event after every cart mutation, whoever made it.
(function () {
  const CART_MUTATION_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  let refreshTimer;

  function refreshCartIconBubble() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart:changed'));
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(`${root}?sections=cart-icon-bubble`)
        .then((response) => response.json())
        .then((sections) => {
          const bubble = document.getElementById('cart-icon-bubble');
          const html = sections['cart-icon-bubble'];
          if (!bubble || !html) return;
          const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (section) bubble.innerHTML = section.innerHTML;
        })
        .catch((e) => console.error(e));
    }, 100);
  }

  const originalFetch = window.fetch;
  window.fetch = function (resource, ...rest) {
    const request = originalFetch.call(this, resource, ...rest);
    const url = resource instanceof Request ? resource.url : String(resource);
    if (CART_MUTATION_URL.test(url)) {
      request.then(
        (response) => response.ok && refreshCartIconBubble(),
        () => {}
      );
    }
    return request;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (CART_MUTATION_URL.test(String(url))) {
      this.addEventListener('load', () => this.status < 400 && refreshCartIconBubble());
    }
    return originalOpen.call(this, method, url, ...rest);
  };
})();
